import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Images from "../../Assets/Images";
import { Popup } from "@progress/kendo-react-popup";
import {
  Grid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import { process } from "@progress/kendo-data-query";
import { Label } from "@material-ui/icons";
import { margin } from "@mui/system";
import { TreeListSelectionCell } from "@progress/kendo-react-treelist";

const DATA_ITEM_KEY = "userId";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
export default class Dashboard extends Component {
  masterData = [];
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      flag: true,
      scope: "0",
      name: "",
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 5,
        skip: 0,
      },
    };
  }

  init = () => {
    if (this.props.editFlag) {
      return;
    }
    let list = this.props.userList ? this.props.userList : [];
    // let list=userList.filter((item)=>!item.isSuperAdmin&&!item.isTenantAdmin);

    list.map((user) => {
      user["selected"] = false;
      user["accessibility"] = "";
    });

    this.setState({
      data: list,
      selectedState: {
        1: true,
      },
      flag: false,
      name: "",
    });
    this.masterData = list;
  };

  resetFlag = () => {
    this.setState({
      flag: false,
    });
  };

  onSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.data.map((item) => {
      if (item.userId === event.dataItem.userId) {
        item.selected = !event.dataItem.selected;
        if (checked) {
          item["accessibility"] = "0";
        } else {
          item["accessibility"] = "";
        }
      }
      return item;
    });
    this.setState({ data });
  };

  onHeaderSelectionChange = (event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const selectedState = {};
    const data = this.state.data.forEach((item) => {
      selectedState[idGetter(item)] = checked;
      if (checked) {
        item["accessibility"] = "0";
      } else {
        item["accessibility"] = "";
      }
    });
    this.setState({
      selectedState,
      data: data,
    });
  };

  handleAccessibility = (e, dataItem) => {
    const data = this.state.data.map((item) => {
      if (item.userId == dataItem.userId) {
        item["accessibility"] = e.target.value;
      }
      return item;
    });
    this.setState({ data });
  };
  handleUserSelection = (event) => {
    let eventData = this.state.data.find(
      (item) => item.userId === event.dataItem.userId
    );
    return (
      <>
        {eventData.isTenantAdmin || eventData.isSuperAdmin ? (
          <td>
            <span className="noaccess">
              <img
                className="noaccessDashboard"
                title="No access"
                src={Images.NOTACCESS}
                width="12"
                alt=""
              />
            </span>
          </td>
        ) : (
          
          <TreeListSelectionCell {...event} />
          
        )}
      </>
    );
  };
  manageAccessibility = (event) => {
    let eventData = this.state.data.find(
      (item) => item.userId === event.dataItem.userId
    );
    return (
      <td>
        {eventData.isTenantAdmin || eventData.isSuperAdmin ? (
          <div className="accessSpecifier">
            <RadioGroup
              aria-label="accessibility"
              name="accessibility"
              value="1"
              onChange={(e) => this.handleAccessibility(e, eventData)}
            >
              <FormControlLabel
                value="1"
                control={<Radio />}
                label=" Read/Write"
                disabled={eventData && !eventData.selected}
              />
            </RadioGroup>
          </div>
        ) : (
          <div className="accessSpecifier">
            <RadioGroup
              aria-label="accessibility"
              name="accessibility"
              value={eventData ? eventData.accessibility : ""}
              onChange={(e) => this.handleAccessibility(e, eventData)}
            >
              <FormControlLabel
                value="0"
                control={<Radio />}
                label="Read"
                disabled={eventData && !eventData.selected}
              />

              <FormControlLabel
                value="1"
                control={<Radio />}
                label="Read/Write"
                disabled={eventData && !eventData.selected}
              />
            </RadioGroup>
          </div>
        )}
      </td>
    );
  };

  saveDashboard = async () => {
    try {
      let userDetails = await this.getAccessibilityValues();
      let req = {
        name: this.state.name.trim(),
        scope: this.state.scope,
        accessibility: userDetails,
      };
      this.setState({
        flag: true,
      });
      this.props.saveDashboard(req);
    } catch (err) {
      console.error(err);
    }
  };
  updateDashboard = async () => {
    try {
      let userDetails = await this.getAccessibilityValues();
      let req = {
        name: this.state.name.trim(),
        scope: this.state.scope,
        dashBoardId: this.state.dashBoardId,
        accessibility: userDetails,
      };
      this.setState({
        flag: true,
      });
      this.props.updateDashboard(req);
    } catch (err) {
      console.error(err);
    }
  };

  getAccessibilityValues = () => {
    let value = [];
    this.state.data.map((item) => {
      if (item.selected) {
        value.push({
          userId: item.userId,
          accessibility: item.accessibility == "1" ? true : false,
          email: item.email,
        });
      }
    });
    return value;
  };

  CreateDashboardClose = () => {
    this.setState({
      flag: true,
      scope: "0",
      name: "",
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 5,
        skip: 0,
      },
      data: [],
    });
    this.props.CreateDashboardClose();
  };
  mergeUserList = (item) => {
    let list = this.props.userList ? this.props.userList : [];
    let userList = list;
    if (item.scope === 1) {
      userList.map((user) => {
        let access = item.accessibility.find(
          (acc) => user.userId === acc.userId
        );
        if (access) {
          user["selected"] = true;
          user["accessibility"] = access.accessibility ? "1" : "0";
        } else {
          user["selected"] = false;
          user["accessibility"] = "";
        }
      });
    }
    return userList;
  };
  //trigger from parent
  papulateDashboardValues = async (item) => {
    let userList = await this.mergeUserList(item);
    this.setState({
      flag: false,
      scope: item.scope.toString(),
      name: item.name,
      dashBoardId: item.dashboardId,
      data: userList,
      selectedState: {
        1: true,
      },
    });
    this.masterData = this.state.data;
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  searchUserFromList = (e) => {
    this.setState({
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 5,
        skip: 0
      }
    });

    let temp = [];
    this.masterData.map((item, j) => {
      if (item.displayName.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())) {
        temp.push(item);
      }
    });
    this.setState({
      data: temp
    });
  }
  render() {
    if (this.props.openCreateDashboard && this.state.flag) {
      this.init();
    }
    return (
      <div>
        <Popup
          show={this.props.openCreateDashboard}
          popupClass={"popup-content"}
        >
          <form name="dashboardname">
            <div className="createDashboardDialog">
              {this.props.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <h4>
                {this.props.editFlag ? "Update Dashboard" : "Create Dashboard"}
              </h4>
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-10">
                  <div className="formControl">
                    <label>Dashboard Name</label>
                    <input
                      type="text"
                      value={this.state.name}
                      onChange={(e) =>
                        this.setState({
                          ...this.state,
                          name: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="accessSpecifier">
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  value={this.state.scope}
                  onChange={(e) =>
                    this.setState({
                      ...this.state,
                      scope: e.target.value,
                    })
                  }
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Shared"
                  />

                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="Private"
                  />
                </RadioGroup>
              </div>

              {this.state.scope === "1" && (
                <div className="dataGrids userTable">
                  <div className="userTableTitle">
                    <p style={{color:'#FFFFFF', marginBottom: '0.1rem', width:'60%'}}>Select Users</p>
                    <div className="searchInputDiv">
                      <span className="searchIcon">
                        <img src={Images.SEARCHICON} width="12" alt="Search" />
                      </span>
                      <input
                        type="text"
                        placeholder="Search"
                        name="search"
                        onChange={(e) => this.searchUserFromList(e)}
                      />
                    </div>
                  </div>
                  <Grid
                    data={process(this.state.data, this.state.dataState)}
                    {...this.state.dataState}
                    style={{
                      height: "auto",
                    }}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    selectable={{
                      enabled: true,
                      drag: false,
                      cell: false,
                      // mode: "multiple",
                    }}
                    onSelectionChange={this.onSelectionChange}
                    // onHeaderSelectionChange={this.onHeaderSelectionChange}
                    reorderable
                    resizable
                    pageable={true}
                    total={this.state.data.length}
                    onDataStateChange={(e) => {
                      this.setState({ dataState: e.dataState });
                    }}
                  >
                    <Column
                      width="50px"
                      field={SELECTED_FIELD}
                      cell={(props) => this.handleUserSelection(props)}

                      // headerSelectionValue={
                      //   this.state.data.findIndex(
                      //     (item) => !this.state.selectedState[idGetter(item)]
                      //   ) === -1
                      // }
                    />

                    <Column field="displayName" title="Name" width="250px" />
                    <Column
                      field="accessibility"
                      title="Accessibility"
                      width="250px"
                      cell={(props) => this.manageAccessibility(props)}
                    />
                  </Grid>
                </div>
              )}
              <div className="btnCont">
                {this.props.editFlag ? (
                  <button
                    className="btnGreen"
                    type="button"
                    disabled={!this.state.name}
                    onClick={this.updateDashboard}
                  >
                    Update Dashboard
                  </button>
                ) : (
                  <button
                    className="btnGreen"
                    type="button"
                    disabled={!this.state.name}
                    onClick={this.saveDashboard}
                  >
                    Save Dashboard
                  </button>
                )}

                <button
                  className="btnRed"
                  type="button"
                  onClick={this.CreateDashboardClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        
        </Popup>
      </div>
    );
  }
}
